import { useParams } from 'react-router-dom';
import { getFormTypeFromUrl } from '../helpers/formTypeMapper';

export const useFormType = () => {
  const { formType } = useParams<{ formType: string }>();
  return getFormTypeFromUrl(formType);
};
